module.exports = {"441226001":"德城街道","441226101":"新圩镇","441226102":"回龙镇","441226103":"官圩镇","441226105":"马圩镇","441226106":"高良镇","441226107":"莫村镇","441226109":"永丰镇","441226110":"武垄镇","441226111":"播植镇","441226112":"凤村镇","441226113":"悦城镇","441226114":"九市镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441226.json
// module id = 2143
// module chunks = 0